import { useIntl } from "react-intl";
import { useQuery } from "react-query";

import AutocompleteWithQuery, {
  AutocompleteWithQueryProps,
} from "components/AutocompleteWithQuery";
import useGlobalContext from "hooks/globalData";
import {
  BaseFilter,
  ListRequestOfBaseFilter,
  ListResponseOfProductType,
  ProductType,
} from "services/KnowfullyAdminClient";

type SelectProductTypeProps = Omit<
  AutocompleteWithQueryProps<ProductType>,
  "fetchedData" | "failMessage" | "labelField"
>;

const SelectProductType = (props: SelectProductTypeProps) => {
  const { formatMessage: t } = useIntl();
  const { productService } = useGlobalContext();

  const fetchedProductTypes = useQuery<ListResponseOfProductType>(
    ["productTypes"],
    () =>
      productService.getProductTypes(
        ListRequestOfBaseFilter.fromJS({
          parameters: BaseFilter.fromJS({}),
          sortField: "name",
        })
      )
  );

  return (
    <AutocompleteWithQuery
      {...props}
      labelField="name"
      fetchedData={fetchedProductTypes}
      failMessage={t({ id: "selectProductTypeFetchFailed" })}
    />
  );
};

export default SelectProductType;
